export enum ChartType {
    ATM_IV = 'atmIv',
    DELTA_SKEW = 'deltaSkew',
    DELTA_BUTTERFLY = 'deltaButterfly',
}